import { render, staticRenderFns } from "./scalePie.vue?vue&type=template&id=4f902954"
import script from "./scalePie.vue?vue&type=script&lang=js"
export * from "./scalePie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports